module.exports = __webpack_public_path__ + "media/images/sample-sitter-3-70ad3c420ec8cffd05ffd3f407aca11b.jpg";